class Animation {
    constructor(options={args:null, fn: null, prepareFn: null, doneFn: null}) {
        this.args = options.args;
        this.fn = options.fn;
        this.doneFn = options.doneFn;
        this.prepareFn = options.prepareFn
        this.checkFn = options.checkFn;
        this.iterations = 0;

        if(this.args && this.fn) {
            this.running = true;

            if(this.prepareFn) {
                this.prepare = true;
            }
            if(this.doneFn) {
                this.clean = true
            }
        }
    }

    iterate() {
        if(this.prepare) {
            this.prepareFn(this.args);
            this.prepare = false;
        }

        if(this.running) {
            this.iterations++;

            this.running = this.fn(this.args, this.iterations);

            if(this.clean && !this.running) {
                this.doneFn(this.args);
            }
        }
    }

    isRunning() {
        return this.running;
    }
}

export default Animation;
